<template>
  <div>
    <h4 class="text-center text-lighter font-weight-normal mt-5 mb-0">Request a password reset</h4>
    <div class="my-5">
      <p class="text-center text-big">Enter your email and we will sent restoration link.</p>
    </div>
    <!-- Form -->
    <form class="my-5">
      <b-form-group label="Your email" :feedback="errors.email" :invalid-feedback="errors.email">
        <b-input v-model="email" :state="!errors.email" type="email" required />
      </b-form-group>
      <b-btn variant="primary" :block="true" class="mt-4" @click="request">Reset password</b-btn>
    </form>
    <!-- / Form -->

    <div class="text-center text-muted">
      <router-link :to="{ name: 'login' }">Sign In</router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'password-reset-request',
  data: () => ({
    email: '',
    errors: {}
  }),
  methods: {
    ...mapActions('auth', ['passwordResetRequest']),
    request() {
      if (this.email.length) {
        this.$set(this, 'errors', {})
        this.passwordResetRequest({ email: this.email })
          .then((r) => {
            window.location = r.data.redirectUrl
          })
          .catch((error) => {
            if (error.response) {
              switch (error.response.status) {
                case 422:
                  this.$set(this, 'errors', error.response.data.errors)
                  break
                case 404:
                  this.$set(this, 'errors', { email: 'Email not found!' })
                  break
                default:
                  throw error
              }
            } else {
              throw error
            }
          })
      }
    }
  },
  created() {
    if (this.$route.query && this.$route.query.email) {
      this.email = this.$route.query.email
    }
  }
}
</script>

<style scoped></style>
